// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F9J5U{display:flex;flex-direction:column;border-radius:4px;box-shadow:0px 4px 16px rgba(40,40,99,.08);background:#f3f5ff}.F9J5U.Ran5y{background:#f3f5ff}.F9J5U.Ran5y .kR3FY{color:var(--button-primary, #6942f8)}.F9J5U.Ran5y.BB_kH{border:1px solid #8768f9}.F9J5U.fEGz2{background:#fdf0f0}.F9J5U.fEGz2 .kR3FY{color:#eb7272}.F9J5U.fEGz2.BB_kH{border:1px solid #eb7272}.F9J5U.KtA71{background:#fdf2dc}.F9J5U.KtA71 .kR3FY{color:#dd9306}.F9J5U.KtA71.BB_kH{border:1px solid #dd9306}.F9J5U.MYoCZ{border-radius:8px;box-shadow:none}.F9J5U.ouLYP,.F9J5U.ouLYP.Ran5y,.F9J5U.ouLYP.KtA71,.F9J5U.ouLYP.fEGz2{background:transparent;border:none;box-shadow:none}.Fziwh{display:flex;gap:12px;border-radius:4px;padding:8px 12px;align-items:flex-start;text-align:start}.MYoCZ .Fziwh{border-radius:8px}.kR3FY{flex-shrink:0;display:flex;justify-content:center;width:18px;align-self:center}.I0SQ6{align-self:center;flex:1}.pBZfM{padding:0 12px 8px}.pBZfM.T4bSi{padding-left:42px}.XWbjj{margin:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"root": `F9J5U`,
	"info": `Ran5y`,
	"icon": `kR3FY`,
	"border": `BB_kH`,
	"error": `fEGz2`,
	"warning": `KtA71`,
	"mobile": `MYoCZ`,
	"transparent": `ouLYP`,
	"main": `Fziwh`,
	"content": `I0SQ6`,
	"actionRow": `pBZfM`,
	"withIcon": `T4bSi`,
	"footer": `XWbjj`
};
export default ___CSS_LOADER_EXPORT___;
